
import React from 'react';
import { useCompanyImages } from './useCompanyImages';
import BannerUpload from './BannerUpload';
import LogoUpload from './LogoUpload';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const ImageUploadForm = () => {
  const { 
    logoPreview, 
    bannerPreview,
    isLoading, 
    handleLogoChange,
    handleBannerChange,
    handleRemoveLogo, 
    handleRemoveBanner,
    handleSubmit
  } = useCompanyImages();
  
  const resetImages = () => {
    handleRemoveLogo();
    handleRemoveBanner();
  };
  
  const hasChanges = !!logoPreview || !!bannerPreview;

  return (
    <div className="space-y-8 max-w-4xl mx-auto">
      <Card>
        <CardHeader>
          <CardTitle>Company Images</CardTitle>
          <CardDescription>
            Upload or update your company's logo and banner images
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="grid md:grid-cols-2 gap-8">
            <LogoUpload 
              logoPreview={logoPreview} 
              onLogoChange={handleLogoChange}
              onRemoveLogo={handleRemoveLogo}
            />
            <BannerUpload 
              bannerPreview={bannerPreview} 
              onBannerChange={handleBannerChange}
              onRemoveBanner={handleRemoveBanner}
            />
          </div>
          
          <div className="flex justify-end gap-4 pt-4">
            <Button 
              variant="outline" 
              onClick={resetImages}
              disabled={isLoading || (!logoPreview && !bannerPreview)}
            >
              Reset
            </Button>
            <Button 
              onClick={handleSubmit}
              disabled={isLoading || (!logoPreview && !bannerPreview)}
            >
              {isLoading ? "Saving..." : "Save Images"}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ImageUploadForm;

